/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { clientSideOnly } from '@atlassian/jira-common-client-side-only/src/index.tsx';

export const communicationsStakeholdersEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		clientSideOnly(
			import(
				/* webpackChunkName: "async-communications-stakeholders-entrypoint" */ './src/ui/StakeholdersPage'
			).then((module) => module.StakeholdersPage),
		),
	),
	getPreloadProps: () => ({}),
});
